import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyUserAccessPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UserAccessPage" */ '../src/UserAccess/UserAccessPage.tsx'
			)
		).UserAccessPage,
});
